<div class="dasboard-width font-13">
  <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
  <div class="row header mar-lft-rgt-0">
    <div class="col-md-4">Create Ticket</div>
    <div class="col-md-4"> Organization -{{clientName}}</div>
    <div class="col-md-4">
      <ol class="breadcrumb cust-bread ">
        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting('dashboard')"><i
          class="fa fa-dashboard"></i> Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">CreateTicket</li>
      </ol>
    </div>
  </div>
  <div class="content mr-top-5 ">
    <div class="row mar-lft-rgt-0 font-16">
      <div class="col-sm-12 pad-15">
        <div class="height-40" [hidden]="ticketTypeLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <mat-radio-group (change)="onButtonChange($event)" [hidden]="!ticketTypeLoaded">
          <!--<div *ngFor="let button of radioButton;">-->
          <mat-radio-button *ngFor="let button of radioButton;" [value]="button"
                            [checked]="button.checked">{{button.name}}</mat-radio-button>&nbsp;&nbsp;
          <!--</div>-->
        </mat-radio-group>
      </div>
    </div>

    <div class="row mar-lft-rgt-0 font-16" [hidden]="!subRadioDisplay">
      <div class="col-sm-12 pad-15">
        <mat-radio-group (change)="onSubButtonChange($event)">
          <mat-radio-button *ngFor="let button of subtypes;" [value]="button"
          >{{button.type}}
          </mat-radio-button>&nbsp;&nbsp;
        </mat-radio-group>
      </div>
    </div>

    <!--<div class="row mar-lft-rgt-0 ">-->
    <!--<div class="col-md-2 pad-15">-->
    <!--<input class="form-control font-13" type="text" placeholder="{{mocVal}}">-->
    <!--</div>-->
    <!--<div class="col-md-8 pad-15">-->
    <!--<input class="form-control radius-0 font-13" type="text" placeholder="Select SOP Description...">-->
    <!--</div>-->
    <!--</div>-->
    <div class="row mar-lft-rgt-0">
      <div class="col-md-12 pad-15">
        <div class="height-40" [hidden]="categoryLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;"
                (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}"
                [hidden]="!categoryLoaded">
          <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
      </div>
    </div>
    <div class="row mar-lft-rgt-0">
      <div class="form-group col-md-2" *ngFor="let field of dynamicFields;" [ngSwitch]="field.fieldType">
        <input *ngSwitchCase="'1'" type="text" class="form-control radius-0 font-13" placeholder="{{field.fieldName}}"
               [(ngModel)]="field.value">
        <select *ngSwitchCase="'3'" class="form-control radius-0 font-13 " [(ngModel)]="field.value">
          <option *ngFor="let opt of field.values" [value]="opt">{{opt}}</option>
        </select>
      </div>
    </div>
    <div class="row mar-lft-rgt-0">

      <div class="col-md-7 ">
        <div class="col-md-8 search-box" [hidden]="!displayed">
          <mat-form-field class="example-chip-list">
            <mat-chip-list #chipList>
              <mat-chip color="primary" selected *ngFor="let ticket of Tickets" [selectable]="selectable"
                        [removable]="removable" (removed)="remove(ticket)">
                {{ticket}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <input placeholder="Search"
                     [matChipInputFor]="chipList"
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     [matChipInputAddOnBlur]="addOnBlur">
              <!--(matChipInputTokenEnd)="add($event)"-->
            </mat-chip-list>
          </mat-form-field>
          <!--<input type="search" class="search-field" placeholder="Search" [(ngModel)]="searchField">-->

        </div>
        <div class="col-md-4" style="float: right" [hidden]="!displayed">
          <button type="button" class="btn btn-success radius-0 font-13" (click)="openModal(content)">Attach CI</button>
        </div>
        <!--=========================== reactive problem search ==============================================-->
        <div class="col-md-8 search-box" [hidden]="!reactiveSearchDisplay">
          <mat-form-field class="example-chip-list">
            <mat-chip-list #chipList>
              <mat-chip color="primary" selected *ngFor="let data of addedTicket" [selectable]="selectable"
                        [removable]="removable" (removed)="removeReactiveProblemData(data)">
                {{data.id}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <input placeholder="Search"
                     [matChipInputFor]="chipList"
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     [matChipInputAddOnBlur]="addOnBlur">
              <!--(matChipInputTokenEnd)="add($event)"-->
            </mat-chip-list>
          </mat-form-field>
          <!--<input type="search" class="search-field" placeholder="Search" [(ngModel)]="searchField">-->

        </div>
        <div class="col-md-4" style="float: right" [hidden]="!reactiveSearchDisplay">
          <button type="button" class="btn btn-success radius-0 font-13" (click)="ticketModal(contentData)">Attach
            Incident
          </button>
        </div>
        <!--=========================================================================================================-->
        <div class="form-group">
          <input type="text" class="form-control radius-0 font-13"
                 placeholder="Enter Requester info (Ex. Name, phone number , email etc)" [(ngModel)]="name">
        </div>
        <div class="form-group">
          <input type="text" class="form-control radius-0 font-13"
                 placeholder="Ticket description" [(ngModel)]="desc">
        </div>
        <div class="form-group">
          <textarea class="form-control radius-0 font-13 height-120"
                    placeholder="Brief description" [(ngModel)]="brief"></textarea>
        </div>
      </div>

      <div class="col-md-5">
        <div class="card">
          <div class="card-header card-header-top">
            <b>Realtime Solution Database (RSDB)</b>

          </div>
          <div class="card-body card-body-grid" style="height:150px;overflow: auto;padding:3px;">
            <table class="table">
              <thead class="thead-light">
              <tr class="rsdb-head">
                <th>Ticket Id</th>
                <th>Title</th>
                <th>Desc</th>
                <th>Status</th>
                <th>Created Date</th>
              </tr>
              </thead>
              <tbody class="rsdb-body">
              <tr *ngFor="let rsdb of rsdbData" (click)="clickRsdb(ticketcontent, rsdb.id)">
                <td>{{rsdb.ticket_id}}</td>
                <td>{{rsdb.tName}}</td>
                <td>{{rsdb.longDesc}}</td>
                <td>{{rsdb.ticket_status}}</td>
                <td>{{rsdb.createdate | date:'medium'}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row mar-lft-rgt-0">
      <div class="col-sm-6 pad-15 text-center">
        <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                                 (complete)="onFileComplete($event)"></app-material-fileupload>
      </div>
      <div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="hideAttachment">{{attachMsg}} uploaded successfully
      </div>
    </div>
    <div class="row mar-lft-rgt-0">
      <div class="col-md-6 pad-15">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Requested Date</label>
          <div class="col-sm-8">
            <input [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" class="form-control radius-0 font-13"
                   [(ngModel)]="rDate">
            <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
          </div>
        </div>

      </div>
      <div class="col-md-6 pad-15">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Due Date</label>
          <div class="col-sm-8">
            <input [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4" class="form-control radius-0 font-13"
                   [(ngModel)]="dDate">
            <owl-date-time [pickerType]="'calendar'" #dt4></owl-date-time>
          </div>
        </div>
      </div>
    </div>
    <div class="row mar-lft-rgt-0">
      <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
        <select class="custom-select" [(ngModel)]="impact" (change)="onImpactChange($event)">
          <option *ngFor="let map of impacts" [value]="map.id">{{map.name}}</option>
        </select>
      </div>
      <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
        <select class="custom-select" [(ngModel)]="urgency" (change)="onUrgencyChange($event)">
          <option *ngFor="let map of urgencies" [value]="map.id">{{map.name}}</option>
        </select>
      </div>
      <div class="col-sm-4 pad-15">
        <input class="form-control radius-0 font-13" type="text" [(ngModel)]="priority" placeholder="Priority" readonly>
      </div>
    </div>
    <div class="row mar-lft-rgt-0">
      <div class="col-sm-6 pad-15">
        <button type="button" class="btn btn-success btn-block radius-0 font-13" (click)="createTicket()">Create
        </button>
      </div>
      <div class="col-sm-6 pad-15">
        <button type="button" class="btn btn-success btn-block radius-0 font-13" (click)="resetField()">Reset</button>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal let-c="close">
  <div class="modal-header">
    <h4 class="modal-title">Asset management</h4>
    <button type="button" class="close" aria-label="Close" (click)="c()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group row">
      <div class="col-md-3">
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="masterNameSelected"
                (change)="onMasterChange($event.target.selectedIndex)">
          <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
        </select>
      </div>
      <div class="col-md-3">
        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="columnNameSelected"
                (change)="onClientChange($event.target.selectedIndex)">
          <option *ngFor="let column of columnDataObj" [value]="column.columnId">{{column.columnName}}</option>
        </select>
      </div>
      <div class="col-md-3">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="assetValue"
               placeholder="Digital Asset value">
      </div>
      <div class="col-md-3">
        <button type="button" class="btn btn-primary radius-0 font-13" (click)="submitAssetData()">Submit</button>
      </div>
    </div>
    <div class="overflow-auto">
      <angular-slickgrid gridId="grid1"
                         [columnDefinitions]="columnDefinitions"
                         [gridOptions]="gridOptions"
                         (onAngularGridCreated)="angularGridReady($event)"
                         gridWidth="4000"
                         gridHeight="300"
                         (sgOnSelectedRowsChanged)="handleSelectedRowsChanged($event.detail.eventData, $event.detail.args)"
                         [dataset]="data">
      </angular-slickgrid>
    </div>
  </div>
  <div class="modal-footer">
    <ngb-pagination [collectionSize]="collectionSize" (pageChange)="onPageChange($event)" [(page)]="page"
                    [pageSize]="pageSize" aria-label="Default pagination"></ngb-pagination>
    <button type="button" class="btn btn-success btn-block radius-0 font-13" (click)="saveData()" style="
    margin-top: 8px;">Save
    </button>
    <button type="button" class="btn btn-warning btn-block radius-0 font-13" (click)="c()">Close</button>
  </div>
</ng-template>

<ng-template #contentData let-modal let-c="close">
  <div class="modal-header">
    <h4 class="modal-title">View Incident Ticket</h4>
    <button type="button" class="close" aria-label="Close" (click)="c()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body height-450 overY-hidden">
    <div class="form-inline mar-top-15">
      <div class="form-group offset-4 col-sm-4">
        <label for="ticketId" class="sr-only">Ticket Id</label>
        <input type="text" class="form-control font-13 radius-0" [(ngModel)]="searchTid" id="ticketId"
               placeholder="Enter Ticket Id">&nbsp;
        <button type="button" class="btn btn-primary font-13 radius-0" (click)="searchTicket()">Search</button>
      </div>

    </div>
    <div class="col-sm-12 height-250">
      <angular-slickgrid gridId="grid2"
                         [columnDefinitions]="ticketColumnDefinitions"
                         [gridOptions]="gridOptions2"
                         (onAngularGridCreated)="angularGridReady2($event)"
                         gridWidth="2200"
                         (sgOnSelectedRowsChanged)="handleSelectedRowsChanged2($event.detail.eventData, $event.detail.args)"
                         [dataset]="dataset">
      </angular-slickgrid>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success btn-block radius-0 font-13   mar-top-9"
            (click)="addTicket()">Add Ticket ({{ticketCount}})
    </button>
    <button type="button" class="btn btn-danger btn-block radius-0 font-13 mar-top-9"
            (click)="saveReactiveProblemData()">Save
    </button>
    <!--<button type="button" class="btn btn-primary btn-block" (click)="c()">Close</button>-->
  </div>
</ng-template>
<ng-template #ticketcontent let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Ticket Id:{{ticketDetails.ticket_id}} <span class="close" (click)="c()" aria-hidden="true">&times;</span>
    </div>

  </div>
  <div class="modal-body modal-height pad-top-0">
    <mat-tab-group (selectedTabChange)="tabClick($event)">
      <mat-tab label="Ticket Details">
        <div>
          <div class="row mar-lft-rgt-0">
            <div class="col-md-12 pad-7">
              <select class="custom-select  tcktyp" *ngFor="let ticket of ticketAllTypes" [disabled]="true">
                <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="row mar-lft-rgt-0">
                <span class="type">Status:</span>&nbsp; <span class="status">{{ticketDetails.status}}</span>
              </div>
              <div class="row mar-top-9">
                <div class="form-group row mar-lft-rgt-0">
                  <label class="col-form-label col-sm-2 font-13">Priority</label>
                  <div class="col-sm-10">
                    <input type="text" class="form-control font-13" [disabled]="true"
                           [(ngModel)]="ticketDetails.priority"
                           placeholder="Priority">
                  </div>
                </div>
                <div class="form-group col-sm-12">
                  <input type="text" class="form-control radius-0 font-13"
                         placeholder="Enter Requester info (Ex. Name, phone number , email etc)"
                         [(ngModel)]="ticketDetails.reqInfo">
                </div>
                <div class="form-group col-sm-12">
                  <input type="text" class="form-control radius-0 font-13"
                         placeholder="Ticket description" [(ngModel)]="ticketDetails.tName">
                </div>
                <div class="form-group col-sm-12">
                  <textarea class="form-control radius-0 font-13 height-120"
                            placeholder="Brief description" [(ngModel)]="ticketDetails.longDesc"></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="row mar-lft-rgt-0">
            <div class="col-sm-6 pad-7">
              <div class="form-group row">
                <label class="col-sm-4 col-form-label font-13">Requested Date</label>
                <div class="col-sm-8">
                  <input [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3"
                         class="form-control radius-0 font-13"
                         [(ngModel)]="ticketDetails.requestedDate" [disabled]="true">
                  <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
                </div>
              </div>

            </div>
            <div class="col-sm-6 pad-7">
              <div class="form-group row">
                <label class="col-sm-4 col-form-label font-13">Due Date</label>
                <div class="col-sm-8">
                  <input [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4"
                         class="form-control radius-0 font-13"
                         [(ngModel)]="ticketDetails.dDate" [disabled]="true">
                  <owl-date-time [pickerType]="'calendar'" #dt4></owl-date-time>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Solutions">
        <div class="col-sm-12 mar-top-15">

          <div class="stepper-container vertical">
            <div class="stepper">
              <div class="step" *ngFor="let solution of solutions;">
                <div class="step-inner">
                  <div class="step-circle"><span><i class="fa fa-user"></i></span></div>
                </div>
                <div class="step-content col-sm-12 mar-top-15 mar-lft-rgt-0">
                  <div class="card radius-0">
                    <div class="card-header radius-0 card-header-top stepper-head">
                      <b>{{solution.name}}</b>
                      <b class="right"> {{solution.createddate | date:'medium'}}</b>
                    </div>
                    <div class="card-body">
                      {{solution.solutions}}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

</ng-template>
<ng-template #groupSelect>
  <select class="custom-select radius-0 font-13" [(ngModel)]="userGroupSelected" (change)="onSelectGroup()">
    <option *ngFor="let group of userGroups" [value]="group.groupId">{{group.grpName}}</option>
  </select>
</ng-template>
<notifier-container></notifier-container>
